import * as React from "react";
const MidLine = (props) => (
  <svg
    width={9}
    height={442}
    viewBox="0 0 9 442"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect
      x={3.5}
      width={2}
      height={208.5}
      rx={1}
      fill="#1A325D"
      fillOpacity={0.15}
    />
    <rect
      y={216.5}
      width={9}
      height={9}
      rx={4.5}
      fill="#1A325D"
      fillOpacity={0.15}
    />
    <rect
      x={3.5}
      y={233.5}
      width={2}
      height={208.5}
      rx={1}
      fill="#1A325D"
      fillOpacity={0.15}
    />
  </svg>
);
export default MidLine;
